// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"6141c9fe","977":"fd74c01a"}[chunkId] + ".chunk.js";
};